import React from "react";

import { useSupport } from "application/hooks/useSupport";
import { useAppDispatch, useAppSelector } from "application/store";
import { GlobalSliceAction } from "application/store/global/slice";
import { globalSelector } from "application/store/global/selectors";

import SimpleConfirmModal from "../SimpleConfirmModal";

const ContactSupportModal = () => {
  const dispatch = useAppDispatch();
  const { openSupport } = useSupport();
  const { visible, description } = useAppSelector(globalSelector).contactSupportModal;

  const onClose = () => {
    dispatch(GlobalSliceAction.closeContactSupportModal());
  };

  const onSubmit = () => {
    openSupport();
    dispatch(GlobalSliceAction.closeContactSupportModal());
  };

  return (
    <SimpleConfirmModal
      visible={visible}
      title="Contact Support"
      description={description}
      cancelButtonTitle="Cancel"
      submitButtonTitle="Contact Support"
      onClose={onClose}
      onSubmit={onSubmit}
    />
  );
};

export default ContactSupportModal;
